// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import setCardPosition from './components/setCardPosition.vue';

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

(function (KDApi) {
    function SetCardPosition(model) {
        this._setModel(model)
    }

    SetCardPosition.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            this.uniqueId = new Date().getTime();
            this.themeNum = props.themeNum;
            this.setHtml(this.model, props);
        },
        update: function (props) {
            if (props.data && props.data.event === 'update') {
                this.cardPosition_vue.$data.arrCardData = props.data.cardData;
            }
            if (props.data && props.data.event === 'updateButton') {
                this.updateBtn(props.data.cardData)
            }
            if (props.data && props.data.event === 'getData') {
                this.model.invoke('getData', this.cardPosition_vue.$data.arrCardData)
            }
        },

        updateBtn(arrData) {
            for(let i = 0; i < arrData.length; i++) {
                for(let j = 0; j < this.cardPosition_vue.$data.arrCardData.length; j++) {
                    if(arrData[i].isworktimestart.index === this.cardPosition_vue.$data.arrCardData[j].isworktimestart.index) {
                        this.cardPosition_vue.$data.arrCardData[j].isworktimestart = arrData[i].isworktimestart;
                        break;
                    }
                    if(arrData[i].isworktimeend.index === this.cardPosition_vue.$data.arrCardData[j].isworktimeend.index) {
                        this.cardPosition_vue.$data.arrCardData[j].isworktimeend = arrData[i].isworktimeend;
                        break;
                    }
                    if(arrData[i].isopenvalid.index === this.cardPosition_vue.$data.arrCardData[j].isopenvalid.index) {
                        this.cardPosition_vue.$data.arrCardData[j].isopenvalid = arrData[i].isopenvalid;
                        break;
                    }
                }
            }
        },

        setHtml(model, props){
            let $this = this;
            $this.cardData = props.data ? props.data.cardData : [
                // {
                //     "time": {value: '工作时段1', disable: false, index: 1},
                //     "isworktimestart": {value: 1, disable: true, index: 2},
                //     "isworktimeend": {value: 1, disable: false, index: 3},
                //     "isopenvalid": {value: 2, disable: false, index: 4}
                // },
                // {
                //     "time": {value: '工作时段2', disable: false, index: 5},
                //     "isworktimestart": {value: 0, disable: false, index: 6},
                //     "isworktimeend": {value: 2, disable: true, index: 7},
                //     "isopenvalid": {value: 0, disable: true, index: 8}
                // },
                // {
                //     "time": {value: '工作时段1', disable: false, index: 11},
                //     "isworktimestart": {value: 1, disable: true, index: 22},
                //     "isworktimeend": {value: 1, disable: false, index: 33},
                //     "isopenvalid": {value: 2, disable: false, index: 44}
                // },
                // {
                //     "time": {value: '工作时段2', disable: false, index: 55},
                //     "isworktimestart": {value: 0, disable: false, index: 66},
                //     "isworktimeend": {value: 2, disable: true, index: 77},
                //     "isopenvalid": {value: 0, disable: true, index: 88}
                // }
            ];

            KDApi.loadFile(['./css/index.css', './js/myTool.js'], model, () => {
                $this.cardPosition_vue = new Vue({
                    el: model.dom,
                    template: `<div>
                        <!--<el-button @click="update">update</el-button>-->
                        <!--<el-button @click="updateBtn">updateBtn</el-button>-->
                        <setCardPosition :langMsg="langMsg" :cardData="arrCardData" @clickBtn="btnInvoke"></setCardPosition>
                    </div>`,
                    components: {
                        setCardPosition
                    },
                    data: {
                        arrCardData: $this.cardData,
                        langMsg:{
                            workTime: KDApi.getLangMsg($this.model, 'workTime'),
                            startTimeCard: KDApi.getLangMsg($this.model, 'startTimeCard'),
                            endTimeCard: KDApi.getLangMsg($this.model, 'endTimeCard'),
                            isopenvalid: KDApi.getLangMsg($this.model, 'isopenvalid'),
                            message: KDApi.getLangMsg($this.model, 'message'),
                        }
                    },
                    destoryed() {
                        // console.log('Vue destory')
                    },
                    mounted(){
                        // $this.themeNum = 'red';
                        this.myTool = new window.KdWtcMyTool();
                        console.log(this.myTool);
                        this.$root.$el.style.setProperty('--themeColor', $this.themeNum)
                    },
                    methods: {
                       /* update() {
                            this.arrCardData = [
                                {
                                    "time": {value: '工作时段2', disable: false, index: 5},
                                    "isworktimestart": {value: 0, disable: false, index: 6},
                                    "isworktimeend": {value: 2, disable: true, index: 7},
                                    "isopenvalid": {value: 0, disable: true, index: 8}
                                },
                                {
                                    "time": {value: '工作时段1', disable: false, index: 1},
                                    "isworktimestart": {value: 1, disable: true, index: 2},
                                    "isworktimeend": {value: 1, disable: false, index: 3},
                                    "isopenvalid": {value: 2, disable: false, index: 4}
                                },
                                {
                                    "time": {value: '工作时段3', disable: false, index: 5},
                                    "isworktimestart": {value: 0, disable: false, index: 6},
                                    "isworktimeend": {value: 2, disable: true, index: 7},
                                    "isopenvalid": {value: 0, disable: true, index: 8}
                                }
                            ]
                        },
                        updateBtn() {
                            this.arrCardData[1].isopenvalid = {value: 1, disable: false, index: 4};
                        },*/
                        btnInvoke: function (btnData) {
                            // console.log(this.arrCardData);
                            // console.log(btnData);
                            model.invoke('btnClick', btnData)
                        }
                    }
                })
            })
        }
    };

    // 注册自定义组件
    KDApi.register('wtcsetcardposition', SetCardPosition, {isMulLang: true})
})(window.KDApi);
